module.exports = __webpack_public_path__ + "static/media/register-success.0c017cf0.svg";